/* eslint id-length: 0 */
const mm = (v) => (v / 25.4) * 72;

import { profileHash } from "PFCore/helpers/profile_hash";
import roundtoWholeNumber from "PFCore/helpers/round_to_whole_number";

import getPeriod from "./helpers/get_period";

const localExportBuildPdf = (data, config, order, pdfMake) => {
  const sideColor = config.color.match(/^#[0-9a-fA-F]{6}$/) ? config.color : "#cccccc";
  const headerColor = config.color2.match(/^#[0-9a-fA-F]{6}$/) ? config.color2 : "#bbbbbb";

  const header = (text, options = {}) => {
    const top = options.top === undefined ? 10 : options.top;

    return [
      {
        layout: "noBorders",
        fillColor: headerColor,
        margin: [mm(-10), mm(top), 0, 0],

        table: {
          layout: "noBorders",
          widths: options.side ? [mm(70)] : [mm(210 - 75 - 10)],
          body: [[{ text, style: "header", margin: [mm(10), 0, 0, 0] }]]
        }
      },
      { text: " " }
    ];
  };

  const basicInfo = [
    {
      text: config.isBlindModeOn ? `Candidate ${profileHash(data.id)}` : data.name,
      fontSize: 16,
      bold: true
    },
    { text: data.jobTitle },
    { text: data.companyName }
  ];

  if (data.avatar && !config.isBlindModeOn) {
    basicInfo.unshift({
      image: data.avatar,
      width: mm(55),
      height: mm(55),
      margin: [0, 0, 0, mm(3)]
    });
  }

  if (typeof data.score === "number") {
    const score = roundtoWholeNumber(data.score * 100, 0);
    basicInfo.unshift({ text: `Score: ${score}%`, margin: [0, 0, 0, mm(5)] });
  }

  const contactInfo = [];
  if (data.contactInformationItems && !config.isBlindModeOn) {
    contactInfo.push(header("Contact", { side: true }));
    contactInfo.push(
      data.contactInformationItems.map(({ type, text }) => [
        { text: type, bold: true },
        { text, margin: [0, 0, 0, mm(3)] }
      ])
    );
  }

  const mainItems = order.map((itemName) => {
    if (config.hidden[itemName]) {
      return "";
    }

    if (itemName === "experience") {
      return !data.positions
        ? ""
        : [
            header(data.positions.header),
            data.positions.items.map(({ jobTitle, companyName, startDate, endDate, current, summary }) => [
              { text: [{ text: jobTitle, bold: true }, companyName ? ` in ${companyName}` : ""] },
              { text: getPeriod(startDate, endDate, current), opacity: 0.5, fontSize: 10 },
              summary,
              " "
            ])
          ];
    }

    if (itemName === "summary") {
      return !data.summary || config.summary === false ? "" : [header("Summary"), data.summary];
    }

    const cf = data.customTypes.find(({ type }) => type.name === itemName);
    const cfPresent = cf && cf.text;
    return cfPresent ? [header(cf.displayAs), cf.text] : "";
  });

  const marginMinus10 = {
    text: "",
    margin: [0, 0, 0, mm(-10)]
  };

  return pdfMake.createPdf({
    pageMargins: [mm(10), mm(10), mm(10), mm(10)],

    defaultStyle: { fontSize: 12 },
    styles: {
      header: { fontSize: 12, bold: true, color: "#fff" }
    },

    background: [
      {
        absolutePosition: { x: 0, y: 0 },
        canvas: [{ type: "rect", color: sideColor, x: 0, y: 0, w: mm(75), h: mm(297) }]
      }
    ],

    content: [
      {
        columns: [
          {
            width: mm(75 - 10 - 10),
            color: "#fff",
            stack: [basicInfo, contactInfo]
          },

          { width: mm(20), text: "" },

          {
            width: mm(210 - 75 - 10 - 10),
            stack: [marginMinus10, mainItems]
          }
        ]
      }
    ]
  });
};

export default localExportBuildPdf;
